module.exports = __webpack_public_path__ + "static/author-kasandra-martell-e21099dc89433bbad63e364d2a4be32d.png";